// extracted by mini-css-extract-plugin
module.exports = {"fontGroup":"FontGroup_fontGroup__tLv4M","fontGroupDisabled":"FontGroup_fontGroupDisabled__TKJES","fontGroupDisabledDisabled":"FontGroup_fontGroupDisabledDisabled__AqDz_"};